export class BinningRule {
    min: number;
    max: number;
    name: string;
    start: number;
    end: number;

    constructor(
        min: number,
        max: number,
        name: string,
        start: number,
        end: number,
    ) {
        this.min = min; // used in equal-width binning
        this.max = max; // used in equal-width binning
        this.name = name;
        this.start = start; // used in depth/frequency binning
        this.end = end; // used in depth/frequency binning
    }

    public draw() {
        return (
            <div className="px-4">{ this.name }</div>
        )
    }
}